import React from 'react';
import { createReactRenderDecorator } from './ReactRenderDecorator';

function onRender(renderedComponent) {
    return React.cloneElement(renderedComponent, {'data-component': this.constructor.name});
}

export default createReactRenderDecorator(onRender);
